import apiClient from "./client";
import type {
  DisasterStatusCachesResponse,
  GetDisasterStatusCachesParams,
} from "../types/disaster";

export const getDisasterStatusCaches = async (
  params: GetDisasterStatusCachesParams
): Promise<DisasterStatusCachesResponse> => {
  const { data } = await apiClient.get<DisasterStatusCachesResponse>(
    "/disaster-status-caches",
    {
      params: {
        disaster_id: params.disaster_id,
        site_id: params.site_id,
      },
    }
  );
  return data;
};
